import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlightAsterisk'
})
export class HighlightAsteriskPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        if (!value) {
            return value;
        }

        // Check if the text ends with a '*' and replace it with the span tag.
        if (value.endsWith('*')) {
            const highlighted = '<span style="font-weight: 600;">' + value + '</span>'
            return this.sanitizer.bypassSecurityTrustHtml(highlighted);
        } else {
            return value;
        }
    }

}
